<template>
    <div class="image-upload">
        <div class="image-upload-list">
            <div class="image-upload-item" v-for="(item, index) in images" :key="index">
                <el-image
                    ref="image"
                    style="width: 100%; height: 100%"
                    :src="item.previewurl"
                    :preview-src-list="[item.previewurl]">
                </el-image>
                <div class="item-mask">
                    <i class="el-icon-view" @click="previewImage(index)"></i>
                    |
                    <i class="el-icon-upload2" @click="reupload(index)"></i>
                    |
                    <i class="el-icon-delete" @click="removeImage(item)"></i>
                </div>
            </div>
            <el-upload v-show="images.length < limit" :action="uploadUrl" class="image-uploader image-upload-item"
                       ref="uploader" :accept="type.join(',')" :data="uploadParams" :multiple="false"
                       :show-file-list="false"
                       :on-success="handleSuccess" :before-upload="beforeUpload">
                <div class="upload-picker">
                    <i class="el-icon-plus"></i>
                    <div>点击上传图片</div>
                </div>
            </el-upload>
        </div>
    </div>
</template>
<script>

import fa from "element-ui/src/locale/lang/fa";

export default {
    name: 'ImageUpload',
    props: {
        data: {
            type: Array,
            default: () => []
        },
        limit: {
            type: Number,
            default: 1
        },
        size: {
            type: Number,
            default: 1024 * 1024 * 5 // 5M
        },
        type: {
            type: Array,
            default: () => ['.png', '.jpg', '.jpeg']
        },
        cliengguid: {
            type: String,
            default: ''
        },
        clienttag: {
            type: Array,
            default: () => ['']
        },
        dimension: {
            type: Array,
            default: () => [] // 宽高 [180,180]
        }
    },
    data() {
        return {
            uploadUrl: '',
            uploader: null,
            images: [],
            currentImageIndex: -1,
            uploadParams: {
                cliengguid: '',
                clienttag: ''
            },
            uploadLoading: null,
            previewVisible: false,
            previewImageUrl: ''
        };
    },
    mounted() {
        this.uploadUrl = window.service.uploadattachInfo.url;
        this.images = this.data;
        this.uploader = this.$refs.uploader;
    },
    methods: {
        beforeUpload(file) {
            this.uploadParams.cliengguid = this.cliengguid;
            if (this.currentImageIndex < 0) {
                this.uploadParams.clienttag = this.clienttag[this.images.length];
            } else {
                this.uploadParams.clienttag = this.clienttag[this.currentImageIndex];
            }
            // 检查文件大小（限制为10MB）
            if (file.size > this.size) {
                this.$message.error('文件大小不能超过 ' + this.size / 1024 / 1024 + 'MB！');
                return false;
            }

            if (!this.type.includes('.' + this.getFileExtension(file.name))) {
                this.$message.error('只能上传 ' + this.type.join('/') + ' 格式的文件！');
                return false;
            }

            if (this.dimension.length > 1) {
                return this.validDimension(file);
            } else {
                this.uploadLoading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                return true;
            }
        },
        validDimension(file) {
            let dimensionWidth = this.dimension[0],
                dimensionHeight = this.dimension[1];
            return new Promise((resolve, reject) => {
                const _URL = window.URL || window.webkitURL;
                const img = new Image();
                img.onload = () => {
                    if (img.width > dimensionWidth || img.height > dimensionHeight) {
                        reject();
                    } else {
                        resolve();
                    }
                };
                img.onerror = () => {
                    reject();
                };
                img.src = _URL.createObjectURL(file);
            }).then(() => {
                return file;
            }, () => {
                this.$message.error('图片尺寸不能超过 ' + dimensionWidth + 'x' + dimensionHeight + 'px！');
                return Promise.reject();
            })

        },
        handleSuccess(res, file) {
            this.uploadLoading && this.uploadLoading.close();

            this.uploadParams.cliengguid = '';
            this.uploadParams.clienttag = '';
            if (res.code != 200 && res.code != 1) {
                this.$message.error(res.msg);
                return;
            }
            let data = res.data;
            // 将文件转换为base64
            const reader = new FileReader();
            reader.readAsDataURL(file.raw);
            reader.onload = () => {
                const base64 = reader.result;
                if (!data.previewurl) {
                    data.previewurl = base64;
                }
                if (this.currentImageIndex >= 0) {
                    this.$set(this.images, this.currentImageIndex, data);
                } else {
                    this.images.push(data);
                }
                this.currentImageIndex = -1;
                this.$emit('change', this.images);
            };

            this.invoiceValid = true;
        },
        getFileExtension(filename) {
            // 从文件名中获取后缀名
            const lastDot = filename.lastIndexOf('.');
            return lastDot === -1 ? '' : filename.slice(lastDot + 1).toLowerCase();
        },
        removeImage(image) {
            const index = this.images.indexOf(image);
            if (index !== -1) {
                this.images.splice(index, 1);
            }
            this.$emit('change', this.images);
        },
        reupload(index) {
            this.currentImageIndex = index;
            this.uploader.$el.querySelector('input').click();
        },
        previewImage(index) {
            this.$refs.image[index].$el.querySelector('.el-image__inner').click();
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/image-upload.scss';
</style>
